<template>
    <div>
        <div class="trip-date">
            <table class="tab-header" cellspacing="0" cellpadding="0">
                <tbody>
                    <tr>
                        <td class="tab-padding nav-button nav-button-left btn-date-step previous"
                            v-on:click="previousDay">
                            <div style="display:table">
                                <div style="display:table-cell; vertical-align:middle;">
                                    <i class="fa fa-angle-left" aria-hidden="true" style="font-size:2em;"></i>
                                </div>
                                <div style="display:table-cell; vertical-align:middle; padding:5px;"
                                    class="nav-button-text">{{ $t('components.trip_search.one_day_back') }}</div>
                            </div>
                        </td>
                        <td class="tab-padding"></td>
                        <td class="tab-padding tab-inner-padding"></td>
                        <td id="tabforwardTravel" class="tab-active">
                            <table style="width:100%;">
                                <tbody>
                                    <tr>
                                        <td class="current-search-weekday">
                                            {{ weekday }}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="current-search-date">
                                            {{ localDateString }}
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </td>
                        <td class="tab-padding tab-inner-padding"></td>
                        <td class="tab-padding"></td>
                        <td class="tab-padding nav-button nav-button-right btn-date-step next" v-on:click="nextDay">
                            <div style="display:table">
                                <div style="display:table-cell; vertical-align:middle; padding:5px;"
                                    class="nav-button-text">{{ $t('components.trip_search.one_day_forward') }}</div>
                                <div style="display:table-cell; vertical-align:middle;">
                                    <i class="fa fa-angle-right" aria-hidden="true" style="font-size:2em;"></i>
                                </div>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div>
            <div class="tab-content">
                <div class="travel-header">
                    <div class="from"><span>{{ $t('components.trip_search.departure') }}</span></div>
                    <div class="to"><span>{{ $t('components.trip_search.arrival') }}</span></div>
                    <div class="duration"><span>{{ $t('components.trip_search.duration') }}</span></div>
                    <div class="transfer-number"><span>{{ $t('components.trip_search.transfers') }}</span></div>
                    <div class="status"><span>{{ $t('components.trip_search.status') }}</span></div>
                    <div class="price"><span>{{ $t('components.trip_search.price') }}</span></div>
                    <div class="select"><span>{{ $t('components.trip_search.select') }}</span></div>
                </div>

                <div class="travel-options" style="position:relative; min-height: 100px;">
                    <div class="travel">


                        <div v-for="(leg, legIndex) in legs" v-bind:key="legIndex" class="travel-object-container">

                            <div class="travel-object" v-bind:class="{ selected: leg.selected }">

                                <div class="section-main">
                                    <div class="mobile-from">{{ $t('components.trip_search.departure') }}</div>
                                    <div class="from notranslate">
                                        {{ getTimeString(leg.steps[0].transit.local_depart_at) }}
                                        {{ leg.steps[0].transit.departure_stop.name }}
                                    </div>
                                    <div class="mobile-to">{{ $t('components.trip_search.arrival') }}</div>
                                    <div class="to notranslate">
                                        {{ getTimeString(leg.steps[leg.steps.length - 1].transit.local_arrive_at) }}
                                        {{ leg.steps[leg.steps.length - 1].transit.arrival_stop.name }}
                                    </div>
                                    <div class="mobile-duration">{{ $t('components.trip_search.duration') }}</div>
                                    <div class="duration">
                                        {{ getDuration(leg.steps[0].transit.depart_at,
                                            leg.steps[leg.steps.length - 1].transit.arrive_at) }}
                                    </div>
                                    <div class="mobile-transfer-number">{{ $t('components.trip_search.transfers') }}
                                    </div>
                                    <div class="transfer-number">
                                        {{ leg.vehicle_change_times }}
                                    </div>
                                    <div class="status">
                                    </div>
                                    <template v-if="leg.available">
                                        <div class="price">
                                            {{ parseFloat(leg.total).toFixed(2) }} {{
                                                $t('components.trip_search.norwegian_krone') }}
                                        </div>
                                        <div class="select">
                                            <button
                                                v-if="!leg.steps.some(s => s.transit.consent_required) || leg.status_consented"
                                                v-bind:class="{ selected: leg.selected }" class="btn-select"
                                                v-on:click="selectLeg($event, leg, legIndex)">{{
                                                    $t('components.trip_search.select_button') }}</button>
                                        </div>
                                    </template>
                                </div>

                                <div class="routes">
                                    <div class="route-list" v-for="(changeRoute, index) in leg.route_list"
                                        v-bind:key="index">
                                        <div v-if="index != 0" class="arrow">
                                            <i class="fa fa-long-arrow-right" aria-hidden="true"></i>
                                        </div>
                                        <div class="image">
                                            <img v-if="changeRoute.vehicle_type == 'boat'"
                                                src="../../assets/images/vehicles/material_boat.svg" />
                                            <img v-else src="../../assets/images/vehicles/material_bus.svg" />
                                        </div>
                                        <div class="route-number">
                                            {{ changeRoute.route_name }}
                                        </div>
                                    </div>
                                    <div class="info-travel-detail" v-on:click="toogleTransits(leg, legIndex)">
                                        <i v-if="leg.transits_visible" class="fa fa-angle-double-up btn-show"></i>
                                        <i v-else class="fa fa-angle-double-down btn-hide"></i>
                                    </div>
                                </div>


                                <div v-if="leg.transits_visible" class="travel-detail-container">
                                    <div class="travel-detail-panel">
                                        <div v-for="(step, j) in leg.steps" v-bind:key="j">
                                            <div class="travel-detail">
                                                <div class="mobile-from">{{ $t('components.trip_search.departure') }}
                                                </div>
                                                <div class="from notranslate">
                                                    {{ getTimeString(step.transit.local_depart_at) }}
                                                    {{ step.transit.departure_stop.name }}</div>
                                                <div class="mobile-to">{{ $t('components.trip_search.arrival') }}</div>
                                                <div class="to notranslate">{{
                                                    getTimeString(step.transit.local_arrive_at)
                                                }}
                                                    {{ step.transit.arrival_stop.name }}</div>
                                                <div class="mobile-duration">{{ $t('components.trip_search.duration') }}
                                                </div>
                                                <div class="duration">{{ getDuration(step.transit.depart_at,
                                                    step.transit.arrive_at) }}</div>
                                                <div class="transfer-number">
                                                    <div v-if="step.transit.available && j != (leg.steps.length - 1)"
                                                        class="image">
                                                        <span v-if="step.transit.change_vehicle"
                                                            class="material-symbols-outlined">
                                                            transfer_within_a_station
                                                        </span>
                                                        <span v-else class="material-symbols-outlined">
                                                            airline_seat_recline_normal
                                                        </span>
                                                    </div>

                                                </div>
                                                <div class="status">
                                                    <div class="travel-detail-status">

                                                        <span v-if="step.transit.available"
                                                            class="status-available-mini"></span>
                                                        <span v-else class="status-not-available-mini"></span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div v-if="step.transit.messages.length > 0"
                                                style="display: flex; align-items: center; color: #cc0204; padding-left: 10px;">
                                                <div style="font-size: 20px;">
                                                    <span class="material-symbols-outlined">
                                                        warning
                                                    </span>
                                                </div>
                                                <div style="padding-left: 10px;">
                                                    <div v-for="message in step.transit.messages" v-bind:key="message">
                                                        {{ message.description }}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                    <div v-if="leg.html_messages.length == 0"
                                        style="display:table; padding:0 0.5em; margin:10px 0 5px 0">
                                        <div style="display:table-row">
                                            <div
                                                style="display: table-cell; vertical-align: middle; font-size:1.5em; vertical-align:top;">
                                                <img src="../../assets/images/info.svg" style="width:16px;"
                                                    class="n2-tooltip">
                                            </div>
                                            <div style="display:table-cell; vertical-align:middle; padding-left:10px;">
                                                <div class="status-description">
                                                    <template v-if="leg.steps[0].transit.available">
                                                        {{ $t('components.trip_search.status_available') }}
                                                    </template>
                                                    <template v-else>
                                                        <template
                                                            v-if="leg.steps[0].transit.unavailable_reason == 'cancelled'">
                                                            {{ $t('components.trip_search.status_cancelled') }}
                                                        </template>
                                                        <template
                                                            v-if="leg.steps[0].transit.unavailable_reason == 'full'">
                                                            {{ $t('components.trip_search.status_no_capacity') }}
                                                        </template>
                                                        <template
                                                            v-if="leg.steps[0].transit.unavailable_reason == 'booking_time_passed'">
                                                            {{ $t('components.trip_search.status_time_passed') }}
                                                            {{ getVehicleName(leg.steps[0].transit.route.name,
                                                                leg.steps[0].transit.journey.number) }}
                                                                {{ $t('components.trip_search.by_phone') }}
                                                                <a style="color: blue;" v-bind:href="getVehiclePhoneLink(leg.steps[0].transit.route.name,
                                                                leg.steps[0].transit.journey.number)">{{ getVehiclePhone(leg.steps[0].transit.route.name,
                                                                    leg.steps[0].transit.journey.number) }}</a>
                                                            
                                                        </template>
                                                    </template>
                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <!-- <div v-if="leg.html_messages.length > 0"
                                    style="display:table; padding:0 0.5em; margin:10px 0 5px 0">
                                    <div style="display:table-row">
                                        <div
                                            style="display: table-cell; vertical-align: middle; font-size:1.5em; vertical-align:top;">
                                            <img src="../../assets/images/info.svg" style="width:16px;"
                                                class="n2-tooltip">
                                        </div>
                                        <div style="display:table-cell; vertical-align:middle; padding-left:10px;">
                                            <div class="message">
                                                <div style="color:#cc0204;" v-html="leg.html_messages">
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div> -->


                                <div v-if="leg.steps.some(s => s.transit.consent_required)"
                                    class="section-agree-term-container">
                                    <div class="section-agree-term">
                                        <label class="n2-checkbox-lable">
                                            <input type="checkbox" class="n2-checkbox-input"
                                                v-model="leg.status_consented" />
                                            <span class="n2-checkbox-text">{{
                                                $t('components.trip_search.read_and_agree') }}</span>
                                        </label>
                                    </div>
                                </div>
                            </div>

                        </div>
                        <div v-if="legs.length == 0 && !loading"
                            style="text-align: center; font-style: italic; padding: 10px;">
                            {{ $t('components.trip_search.no_result') }}
                        </div>

                    </div>
                    <app-loader v-bind:active="loading"></app-loader>
                </div>

            </div>

        </div>
    </div>
</template>
<script>
import { mapGetters } from 'vuex';

import { ShoppingCartService } from '../../services'
import AppLoader from '../../components/shared/loader.vue';
import contactInfo from '../../contact-info-20250514.json';

export default {
    name: 'trip-search',
    components: {
        AppLoader
    },
    props: ['legs', 'date', 'loading', 'time_zone'],
    data: function () {
        return {
            displayLegs: []
        };
    },
    computed: {
        ...mapGetters('globalization', [
            'locale',
            'app_locale'
        ]),
        localDateString: function () {
            return new Date(this.date).toLocaleString(this.locale, { dateStyle: 'short', timeZone: this.time_zone });
        },
        weekday: function () {
            return new Date(this.date).toLocaleString(this.locale, { weekday: 'long', timeZone: this.time_zone });
        }
    },
    watch: {
        'legs': function () {
            this.legs.forEach(leg => {
                let transits_visible = !leg.available || leg.steps.some(s => s.transit.consent_required);
                if (leg.transits_visible_manually) {
                    transits_visible = leg.transits_visible;
                }
                leg.transits_visible = transits_visible;

                //let legData = JSON.parse(leg.data);
                //leg.action_status = legData.action_status;
                let routeList = [];
                var messages = [];
                let changeTimes = 0;
                for (let j = 0; j < leg.steps.length; j++) {
                    let currentTransit = leg.steps[j].transit;
                    if (currentTransit.messages.length > 0) {
                        messages = [...messages, ...currentTransit.messages.map(m => m.description)];
                    }
                    if (j == 0) {
                        routeList.push({
                            route_name: currentTransit.route.name,
                            vehicle_type: currentTransit.vehicle_type
                        });
                    }
                    else {
                        let previousTransit = leg.steps[j - 1].transit;
                        if (this.needChangeBoat(previousTransit, currentTransit)
                            || currentTransit.route.name != previousTransit.route.name) {
                            routeList.push({
                                route_name: currentTransit.route.name,
                                vehicle_type: currentTransit.vehicle_type
                            });
                            previousTransit.change_vehicle = true;
                            changeTimes += 1;
                        }
                    }
                }
                leg.vehicle_change_times = changeTimes;
                leg.route_list = routeList;
                leg.html_messages = [...new Set(messages)].join('<br />');
            });
        }
    },
    created: function () {
        this.shoppingCartService = new ShoppingCartService();
    },
    methods: {
        getVehicle: function (route, journey) {
            let info = contactInfo;
            let routeInfo = info.contact_info.find(a => a.route == route);
            if (routeInfo) {
                let journeyInfo = routeInfo.journeys.find(j => j.journey == journey);
                if (journeyInfo) {
                    return journeyInfo;
                }
            }
            return null;
        },
        getVehicleName: function (route, journey) {
            let journeyInfo = this.getVehicle(route, journey)
            if (journeyInfo) {
                return journeyInfo.vehicle;
            }
            return null;
        },
        getVehiclePhoneLink:function (route, journey) {
            let journeyInfo = this.getVehicle(route, journey)
            if (journeyInfo) {
                return 'tel:' + journeyInfo.phone;
            }
            return null;
        },
        getVehiclePhone: function (route, journey) {
            let journeyInfo = this.getVehicle(route, journey)
            if (journeyInfo) {
                if(this.app_locale=='no')
            {
                return journeyInfo.phone.substring(3);
            }
            else
            {
                return journeyInfo.phone;
            }}
            return null;
        },
        toogleTransits: function (leg, index) {
            leg.transits_visible = !leg.transits_visible;
            leg.transits_visible_manually = true;
            this.$set(this.legs, index, leg)
        },
        selectLeg: function (e, leg, index) {

            //this.legs.forEach((l, i) => {
            //    let newLeg = Object.assign({}, l);
            //    if (index == i) {
            //        newLeg.selected = true;
            //    }
            //    else {
            //        newLeg.selected = false;
            //    }

            //    this.$set(this.legs, i, newLeg)
            //})

            this.legs.forEach((l, i) => {
                if (index == i) {
                    l.selected = true;
                    l.transits_visible = true;
                    l.transits_visible_manually = true;
                }
                else {
                    l.selected = false;
                    l.transits_visible = false;
                    l.transits_visible_manually = true;
                }

                this.$set(this.legs, i, l)
            })

            //leg.transits_visible = true;
            //leg.transits_visible_manually = true;
            //this.$set(this.legs, index, leg)

            this.$emit('leg-selected', leg);
        },
        nextDay: function () {
            if (!this.loading) {
                this.$emit('next-day-selected');
            }
        },
        previousDay: function () {
            if (!this.loading) {
                this.$emit('previous-day-selected');
            }
        },
        getTimeString: function (source) { return new Date(source).toLocaleString('nb-NO', { hour: '2-digit', minute: '2-digit' }); },
        needChangeBoat: function (from, to) {
            let sepcial = false;
            if ((from.route.name == "1025") &&
                ((from.journey.number == 1002 && to.journey.number == 2005)
                    || (from.journey.number == 1016 && to.journey.number == 2018)
                    || (from.journey.number == 3002 && to.journey.number == 4005)
                    || (from.journey.number == 3016 && to.journey.number == 4018)
                    || (from.journey.number == 5003 && to.journey.number == 6004)


                    || (from.journey.number == 1003 && to.journey.number == 1004)
                    || (from.journey.number == 1011 && to.journey.number == 2013)
                    || (from.journey.number == 1012 && to.journey.number == 1013)
                    || (from.journey.number == 1019 && to.journey.number == 1020)
                    || (from.journey.number == 2001 && to.journey.number == 2002)
                    || (from.journey.number == 2006 && to.journey.number == 2007)
                    || (from.journey.number == 2011 && to.journey.number == 2012)
                    || (from.journey.number == 3003 && to.journey.number == 3004)
                    || (from.journey.number == 3011 && to.journey.number == 4013)
                    || (from.journey.number == 3012 && to.journey.number == 3013)
                    || (from.journey.number == 3019 && to.journey.number == 3020)
                    || (from.journey.number == 4001 && to.journey.number == 4002)
                    || (from.journey.number == 4006 && to.journey.number == 4007)
                    || (from.journey.number == 4011 && to.journey.number == 4012)
                    || (from.journey.number == 5002 && to.journey.number == 5003)
                    || (from.journey.number == 5007 && to.journey.number == 5008)
                    || (from.journey.number == 5009 && to.journey.number == 5010)
                    || (from.journey.number == 5011 && to.journey.number == 5012)
                    || (from.journey.number == 5014 && to.journey.number == 6017)
                    || (from.journey.number == 5016 && to.journey.number == 5017)
                    || (from.journey.number == 6001 && to.journey.number == 6002)
                    || (from.journey.number == 6003 && to.journey.number == 6004)
                    || (from.journey.number == 6006 && to.journey.number == 6007)
                    || (from.journey.number == 6008 && to.journey.number == 6009)
                    || (from.journey.number == 6010 && to.journey.number == 6011)
                    || (from.journey.number == 5016 && to.journey.number == 5017)
                    || (from.journey.number == 6012 && to.journey.number == 6013)
                    || (from.journey.number == 6015 && to.journey.number == 6016)
                    || (from.journey.number == 6017 && to.journey.number == 6018)
                )) {
                sepcial = true;
            }
            if ((from.route.name == "510") &&
                ((from.journey.number == 2000 && to.journey.number == 2001)
                )) {
                sepcial = true;
            }
            if ((from.route.name == "700") &&
                ((from.journey.number == 1018 && to.journey.number == 2018)
                )) {
                sepcial = true;
            }
            return sepcial;
        },
        getDuration: function (start, end) {
            var diff = (new Date(end)).getTime() - (new Date(start)).getTime();

            var days = Math.floor(diff / (1000 * 60 * 60 * 24));
            diff -= days * (1000 * 60 * 60 * 24);

            var hours = Math.floor(diff / (1000 * 60 * 60));
            diff -= hours * (1000 * 60 * 60);

            var mins = Math.floor(diff / (1000 * 60));
            diff -= mins * (1000 * 60);

            var seconds = Math.floor(diff / (1000));
            diff -= seconds * (1000);
            return (days ? days + " days " : '')
                + (hours < 10 ? '0' + hours : hours)
                + ":"
                + (mins < 10 ? '0' + mins : mins);
        }
    }
}
</script>
<style lang="sass">
</style>
